import {
  DataGrid,
  GridColDef,
  GridFilterModel,
  GridPaginationModel,
  GridSortModel
} from "@mui/x-data-grid";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  InstitutionNetworkErrors,
  useAllInstitutions
} from "../Institutions/institutionUtils";
import {
  InvitationNetworkErrors,
  InvitationNotifications,
  useOpenSearchUserInvitations
} from "./userInvitationUtils";
import { DataGridErrorOverlay } from "../../common-ui/DataGridErrorOverlay";
import { useAllPrograms } from "../Programs/programUtils";
import Grid from "@mui/material/Unstable_Grid2";

export const SysAdminsUserInvitationsTable = ({
  disableVirtualization = false,
  columns
}: {
  disableVirtualization?: boolean;
  columns: GridColDef[];
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 100
  });
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "email", sort: "asc" }
  ]);
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: []
  });

  const {
    institutions,
    status: institutionsStatus,
    error: institutionsError
  } = useAllInstitutions();

  const { programs } = useAllPrograms();

  const { invitations, status, error, total, nextPage, prevPage } =
    useOpenSearchUserInvitations(
      paginationModel.pageSize,
      sortModel,
      filterModel,
      institutions || [],
      programs || []
    );

  const handlePaginationModelChange = (model: GridPaginationModel) => {
    if (model.page > paginationModel.page) {
      nextPage();
    }
    if (model.page < paginationModel.page) {
      prevPage();
    }
    setPaginationModel(model);
  };

  const handleSortModelChange = (model: GridSortModel) => {
    setSortModel(model);
  };

  const handleFilterModelChange = (model: GridFilterModel) => {
    setFilterModel(model);
  };

  return (
    <Grid
      sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
    >
      {(status === "failed" || error) && (
        <DataGridErrorOverlay
          errorMessage={InvitationNetworkErrors.FetchAllInvitationsError}
        />
      )}
      {(institutionsStatus === "failed" || institutionsError) && (
        <DataGridErrorOverlay
          errorMessage={InstitutionNetworkErrors.FetchAllInstitutionsError}
        />
      )}
      <Grid xs={12} sx={{ flex: 1, minHeight: 0, display: "flex" }}>
        <DataGrid
          disableVirtualization={disableVirtualization}
          aria-label="user-invitations-table-sysadmins"
          rows={invitations || []}
          columns={columns}
          loading={[status, institutionsStatus].includes(
            "loading"
          )}
          rowCount={total}
          localeText={{
            noRowsLabel: t(InvitationNotifications.NoInvitations)
          }}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          filterMode="server"
          filterModel={filterModel}
          onFilterModelChange={handleFilterModelChange}
          onRowClick={(rowData) => {
            const { row } = rowData;
            const { id } = row;
            if (id) {
              navigate(`${id}`);
            }
          }}
          sx={{
            flex: 1,
            minHeight: 0
          }}
        />
      </Grid>
    </Grid>
  );
};
